import { render, staticRenderFns } from "./EquipmentTransferMailModalContent.vue?vue&type=template&id=6bacc4e1"
import script from "./EquipmentTransferMailModalContent.vue?vue&type=script&lang=js"
export * from "./EquipmentTransferMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports